import React from 'react';
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { EntityType } from "@/domain/document-processing/types/entity-types";
import { User2, Building2 } from 'lucide-react';

const typeConfig = {
  individual: {
    icon: User2,
    bgClass: "bg-blue-100 text-blue-800 hover:bg-blue-200",
    iconClass: "text-blue-600"
  },
  organization: {
    icon: Building2,
    bgClass: "bg-purple-100 text-purple-800 hover:bg-purple-200",
    iconClass: "text-purple-600"
  }
} as const;

interface EntityBadgeProps {
  type: EntityType;
  className?: string;
  iconOnly?: boolean;
}

export function EntityBadge({ type, className, iconOnly = false }: EntityBadgeProps) {
  const config = typeConfig[type];
  const Icon = config.icon;
  let label = type.charAt(0).toUpperCase() + type.slice(1);

  return (
    <Badge 
      variant="secondary"
      className={cn(
        "flex items-center gap-1.5",
        config.bgClass,
        className
      )}
    >
      <Icon className={cn("h-3 w-3", config.iconClass)} />
      {!iconOnly && <span className="capitalize">{label}</span>}
    </Badge>
  );
}